import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconDesignServices from 'components/icons/IconDesignServices';
import { colorGray } from 'styles/layout/colors';
const DesignServicesIcon = t0 => {
  const $ = _c(2);
  const {
    color: t1
  } = t0;
  const color = t1 === undefined ? colorGray : t1;
  let t2;
  if ($[0] !== color) {
    t2 = <IconDesignServices width="20" height="26" color={color} />;
    $[0] = color;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
DesignServicesIcon.propTypes = {
  color: PropTypes.string
};
export default DesignServicesIcon;